import React, { useState, useEffect } from 'react';
import LeftSideMenu from '../components/LeftSideMenu';
import UserNav from '../components/UserNav';
import { Link } from 'react-router-dom';
import { Button, Image } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUpdateUserMutation } from '../slices/usersApiSlice';
import Loader from '../components/Loader';
import { config } from '../config/indexConfig';

const templates = [
    {
        id: "default",
        title: 'Developer',
        image: 'images/folio.png',
        editLink: '/edit/devportfolio',
        viewLink: '/',
    },
    {
        id: "tyler-durden",
        title: 'Tyler Durden',
        image: 'images/site2.png',
        editLink: '/edit/devportfolio',
    },
    {
        id: "real-estate",
        title: 'Real Estate',
        image: 'images/site2.png',
        editLink: '/edit/realestate',
    },
    {
        id: "doctor",
        title: 'Doctor',
        image: 'images/site3.png',
        editLink: '/edit/doctor',
    },
    {
        id: "clinic",
        title: 'Clinic',
        image: 'images/site.png',
        editLink: '/edit/clinic',
    }
];

const Appearance = () => {
    const [userInfo, setUserInfo] = useState(() => JSON.parse(localStorage.getItem('userInfo')) || null);
    const [loading, setLoading] = useState(true);
    const [applyingTemplateId, setApplyingTemplateId] = useState(null); // Tracks template being applied
    const [updateUser] = useUpdateUserMutation();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem('userInfo'));
                const accessToken = localStorage.getItem('accessToken');

                if (!storedUser?.id || !accessToken) {
                    throw new Error('User is not authenticated. Please log in again.');
                }

                const response = await fetch(`${config.api.baseUrl}/users/${storedUser.id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch user data');
                }

                const userData = await response.json();
                setUserInfo(userData);
                localStorage.setItem('userInfo', JSON.stringify({
                    ...storedUser,
                    selectedTemplate: userData.selectedTemplate
                }));
            } catch (error) {
                console.error('Error fetching user data:', error);
                toast.error('Failed to load user data');
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const handleApplyTemplate = async (templateId) => {
        try {
            setApplyingTemplateId(templateId); // Set the template ID being applied
            const storedUser = JSON.parse(localStorage.getItem('userInfo'));
            const accessToken = localStorage.getItem('accessToken');

            if (!storedUser || !accessToken) {
                toast.error('User is not authenticated. Please log in again.');
                return;
            }

            const result = await updateUser({
                userId: storedUser.id,
                userData: { selectedTemplate: templateId },
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            }).unwrap();

            console.log('Update result:', result);

            setUserInfo(prev => ({ ...prev, selectedTemplate: templateId }));
            const updatedUserInfo = { ...storedUser, selectedTemplate: templateId };
            localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));

            toast.success('Template applied successfully');
        } catch (error) {
            console.error('Error applying template:', error);
            toast.error(error.data?.message || 'Failed to apply template');
        } finally {
            setApplyingTemplateId(null); // Reset after completion
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className='pagecontent'>
                <LeftSideMenu />
                <div className='pagecontentbox'>
                    <div className='pagebannerflex'>
                        <div className="pagetitle col-lg-6">
                            <h2 className="pagetitleh2">Elevate Your Portfolio's Look With LandingFast Themes!</h2>
                            <p className='content userpagecontent'>Discover the perfect theme for your LandingFast Store. </p>
                        </div>
                        <div className='pagebannerimgbg'>
                            <Image src='images/banner.png' className='bannerimg' alt='bannerimg' />
                        </div>
                    </div>
                </div>
                <div className='pagecontentbox'>
                    <div className='themeflex'>
                        {templates.map((template) => (
                            <div key={template.id} className='themes'>
                                <div className='themeimgbg'>
                                    <Image src={template.image} className='themeimg' alt={template.title} />
                                </div>
                                <div className='applybtn'>
                                    {userInfo && userInfo.selectedTemplate === template.id ? (
                                        <>
                                            <Link to={template.editLink} className='btn customizebtn userbtn sitebtn'>
                                                Customize
                                            </Link>
                                            <Link to={template.viewLink} className='btn userbtn sitebtn'>
                                                View
                                            </Link>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                className='btn userbtn sitebtn'
                                                onClick={() => handleApplyTemplate(template.id)}
                                                disabled={applyingTemplateId === template.id}
                                            >
                                                {applyingTemplateId === template.id ? 'Applying...' : 'Apply'}
                                            </Button>
                                            <Link to={`/preview/${template.id}`} className='prevlink'>
                                                Preview <span><Image src='images/linkprev.svg' className='previmg' alt='prevlink' /></span>
                                            </Link>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default Appearance;
